import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useNavigate } from 'react-router-dom';
import localStorageService from "../services/localStorageService";
import portalService from "../services/portalService";

const Location = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    //const [boxes, setBoxes] = useState([]);
    const [storageLocation, setStorageLocation] = useState({});

    const [boxCode, setBoxCode] = useState("");
    const [boxNum, setBoxNum] = useState(0);
    const [boxLevel, setBoxLevel] = useState(0);
    const [boxWidth, setBoxWidth] = useState(0);
    const [boxHeight, setBoxHeight] = useState(0);
    const [boxDepth, setBoxDepth] = useState(0);
    const [lock, setLock] = useState(0);
    const [boxType, setBoxType] = useState(1);

    useEffect(() => {
        const locations = localStorageService.locations.get();
        const loc = locations[id];
        console.log("Loaded location", loc);
        setStorageLocation(loc);
        if (localStorageService && localStorageService.locks) {
            const existingLocks = localStorageService.locks.get() || [];
            if (existingLocks.length > 0) {
                setLock(existingLocks[0].id);
            }
        }
        
        //setBoxes(loc.storageItems);
    }, [id]);

    const addNew = (e) => {

        const newBox = {
            width: boxWidth,
            height: boxHeight,
            depth: boxDepth,
            boxNum,
            boxCode,
            boxLevel,
            boxType,
            storageLocationId: storageLocation.id,
            storageLockId: lock
        }

        portalService.addBox(newBox)
            .then(r => {
                console.log("Got results", r);
                const existingLock = localStorageService.locks.get().filter(l => l.id == r.data.storageLockId)[0];
                const existing = [...storageLocation.storageItems];
                console.log("Existing", existing);
                existing.push({id: r.data.id, ...newBox, storageLock: existingLock, schedules: []});
                console.log("Existing after push", existing);
                const updatedLocation = {...storageLocation, storageItems: existing};
                const existingLocations = localStorageService.locations.get();
                console.log("All existing locations", existingLocations);
                existingLocations[storageLocation.id] = updatedLocation;

                console.log("Updated existing locations", existingLocations);
                const existingItem = localStorageService.items.get();
                const existingItems = {...existingItem};
                console.log("Existing dic items", existingItems);
                existingItems[r.data.id] = {...newBox, storageLock: existingLock, schedules: [], id: r.data.id};
                localStorageService.locations.set(existingLocations);
                localStorageService.items.set(existingItems);
                console.log("Setting new storage location", updatedLocation);
                setStorageLocation((prevState) => ({
                    ...prevState,
                    storageItems: existing
                }));
                clearFields();
            })
            .catch(e => {

            });
    }

    const modalClosed = (e) => {
        clearFields();
    }

    const clearFields = () => {
        setBoxCode("");
        setBoxDepth(0);
        setBoxHeight(0);
        setBoxWidth(0);
        setBoxLevel(0);
        setBoxNum(0);
        setLock(0);
        setBoxType(1);
    }

    const mapSize = (s) => {
        switch (s) {
            case 1:
                return "XS";
            case 2:
                return "S";
            case 3:
                return "M";
            case 4:
                return "L";
            default:
                return "N/A"
        }
    }
 
    const modal = () => {
        return (
            <div className="modal fade" id="new-location-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 v="modal-title fs-5" id="staticBackdropLabel">Новая ячейка</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form className="form-floating">
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="new-box-code" required placeholder="" value={boxCode} onChange={(e) => setBoxCode(e.target.value)}/>
                                    <label htmlFor="new-box-code">Код ячейки</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="new-box-num" required placeholder="" value={boxNum} onChange={(e) => setBoxNum(e.target.value)}/>
                                    <label htmlFor="new-box-num">Номер ячейки</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="new-box-level" required placeholder="" value={boxLevel} onChange={(e) => setBoxLevel(e.target.value)}/>
                                    <label htmlFor="new-box-level">Ярус ячейки</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="new-box-depth" placeholder="" value={boxDepth} onChange={(e) => setBoxDepth(e.target.value)}/>
                                    <label htmlFor="new-box-depth">Длина</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="new-box-width" placeholder="" value={boxWidth} onChange={(e) => setBoxWidth(e.target.value)}/>
                                    <label htmlFor="new-box-width">Ширина</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="new-box-height" placeholder="" value={boxHeight} onChange={(e) => setBoxHeight(e.target.value)}/>
                                    <label htmlFor="new-box-height">Высота</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <select className="form-select" id="new-box-lock" aria-label="Default select example"
                                        value={lock}
                                        onChange={e => setLock(e.target.value)}>
                                            {localStorageService && localStorageService.locks && localStorageService.locks.get() && localStorageService.locks.get().map(c => (
                                                <option key={`lock-${c.id}`} value={c.id}>{c.serialNumber}</option>
                                            ))}
                                    </select>
                                    <label htmlFor="new-box-lock">Замок</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <select className="form-select" id="new-box-type" aria-label="Default select example"
                                        value={boxType}
                                        onChange={e => setBoxType(parseInt(e.target.value))}>
                                            <option value={1}>XS</option>
                                            <option value={2}>S</option>
                                            <option value={3}>M</option>
                                            <option value={4}>L</option>
                                    </select>
                                    <label htmlFor="new-box-type">Размер</label>
                                </div>
                                <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={modalClosed}>Закрыть</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={addNew}>Сохранить</button>
                        </div>
                            </form>
                        </div>       
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="">
            <h2 className="mb-3">{storageLocation.name}</h2>
            <h5>{storageLocation.address}</h5>
            <hr/>
            <h5 className="mt-5">Ячейки</h5>
            <div>
                <table className="table table-striped table-hover">
                    <thead className="table">
                        <tr>
                            <th scope="col">Номер</th>
                            <th scope="col">Длина</th>
                            <th scope="col">Ширина</th>
                            <th scope="col">Высота</th>
                            <th scope="col">Площадь</th>
                            <th scope="col">Объем</th>
                            <th scope="col">Ярус</th>
                            <th scope="col">Размер</th>
                            <th scope="col">Номер замка</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {storageLocation && storageLocation.storageItems && storageLocation.storageItems.map((row) => (
                            <tr key={row.id}>
                                <td>{row.boxCode}{row.boxNum}</td>
                                <td>{row.depth}</td>
                                <td>{row.width}</td>
                                <td>{row.height}</td>
                                <td>{row.width*row.depth}</td>
                                <td>{row.depth * row.height * row.width}</td>
                                <td>{row.boxLevel}</td>
                                <td>{mapSize(row.boxType)}</td>
                                <td>{row.storageLock.serialNumber}</td>
                                <td>
                                    <button
                                        className="btn btn-info w-100"
                                        onClick={() => {
                                            navigate(`/locations/${id}/boxprices/${row.id}`)
                                        }}
                                    >
                                        Цены
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div>
                    <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#new-location-modal">Добавить+</button>
                </div>
            </div>
            {modal()}
        </div>
    )
}

export default Location;
